/**
 * Campaign order and the scenario registry (docs/SCENARIOS.md).
 * Each scenario unlocks on a pass of the one before it; Sandbox is always available.
 */

import type { Difficulty, ScenarioConfig } from '../engine/types';
import { kettleNarrowsScenarios } from './kettle-narrows';
import { lowerSableScenarios } from './lower-sable';
import { sandbox, makeSandbox } from './sandbox';

export const SCENARIOS: ScenarioConfig[] = [
  ...kettleNarrowsScenarios.filter((s) => s.index < 8),
  ...lowerSableScenarios,
  ...kettleNarrowsScenarios.filter((s) => s.index >= 8),
  sandbox,
].sort((a, b) => a.index - b.index);

export const CAMPAIGN = SCENARIOS.filter((s) => s.id !== 'sandbox');

export function getScenario(id: string): ScenarioConfig {
  const s = SCENARIOS.find((x) => x.id === id);
  if (!s) throw new Error(`unknown scenario: ${id}`);
  return s;
}

export const DIFFICULTIES: Difficulty[] = ['trainee', 'operator', 'chief'];

export const DIFFICULTY_BLURB: Record<Difficulty, string> = {
  trainee: 'Tight forecasts, mild events, hints on, half penalties.',
  operator: 'The defaults. Nominal forecasts, sensor noise, full penalties.',
  chief: 'Hidden failures, noisy sensors, strict penalties, no hints.',
};

export { sandbox, makeSandbox };
export { kettleNarrowsScenarios, lowerSableScenarios };
